const show_login_form = () => {
  let login_form = document.getElementById("login-form")
  let recover_form = document.getElementById("recover-form")
  recover_form.className = "hidden"
  login_form.className = ""

  window.location.hash = "";
}

const show_recover_form = () => {
  let login_form = document.getElementById("login-form")
  let recover_form = document.getElementById("recover-form")
  login_form.className = "hidden"
  recover_form.className = ""
}

const to_register_page = () =>{
  sessionStorage.setItem('autoPageTransition_topPage', '/cart');
  window.location.href="/account/register"
}

window.onload = function () {
  const hash = location.hash;
  if (hash === "#recover") {
    show_recover_form()
  }
}